import { IState } from "@/redux/store.types";
import { getValueState } from "@/redux/utils";

import { $ProductDetailModuleName } from "./productDetail.types";

const getProductDetail = (state: IState) =>
    getValueState(state, $ProductDetailModuleName)!;

const getStickyOrderButton = (state: IState) =>
    !!getValueState(state, $ProductDetailModuleName)?.stickyOrderButton;

export { getProductDetail, getStickyOrderButton };
